__webpack_require__.p = "/cdn/ascm-common/js/";